import { IconButton, type IconType } from "materia"
import { Trans } from "react-i18next"
import { modifiers, sanitizeHtml } from "ui-tools"
import s from "./JourneyInfo.module.scss"

type JourneyInfoProps = {
  avatar: string | null
  description: string | null
  isLocked: boolean
  lockedBy: string[]
  onClose: () => void
}
export const JourneyInfo = ({
  avatar,
  description,
  isLocked,
  lockedBy,
  onClose,
}: JourneyInfoProps) => {
  const showLockedByJourneys = isLocked && lockedBy.length > 0
  const showTopBorder = Boolean(description && isLocked)

  return (
    <div className={s.dimmer} onClick={onClose}>
      <div className={s.journeyInfo}>
        <div className={s.journeyInfo__closeButton}>
          <JourneyInfo.Button
            icon="Close"
            title="Close journey info"
            onClick={onClose}
          />
        </div>

        {description && (
          <Description avatar={avatar} description={description} />
        )}

        {showLockedByJourneys && (
          <LockedByJourneys lockedBy={lockedBy} showTopBorder={showTopBorder} />
        )}
      </div>
    </div>
  )
}

type ButtonProps = {
  icon: IconType
  title: string
  onClick: () => void
}
JourneyInfo.Button = ({ icon, title, onClick }: ButtonProps) => {
  return (
    <IconButton
      as="button"
      icon={icon}
      size="small"
      title={title}
      onClick={onClick}
    />
  )
}

type DescriptionProps = { avatar: string | null; description: string }
const Description = ({ avatar, description }: DescriptionProps) => {
  return (
    <div className={s.description}>
      {avatar && <img src={avatar} className={s.description__avatar} alt="" />}

      <div
        className={s.description__text}
        dangerouslySetInnerHTML={sanitizeHtml(description, "allow-links")}
      />
    </div>
  )
}

type LockedByJourneysProps = {
  lockedBy: string[]
  showTopBorder: boolean
}
const LockedByJourneys = ({
  lockedBy,
  showTopBorder,
}: LockedByJourneysProps) => {
  const lockedByJourneys = lockedBy.join(", ")

  return (
    <div className={modifiers(s, "locked", { showTopBorder })}>
      <Trans
        i18nKey={"journey.LOCKED_BY_JOURNEY"}
        values={{ journeys: lockedByJourneys }}
        components={{ bold: <span className={s.locked__title} /> }}
      />
    </div>
  )
}
